<!-- Form row -->
<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <form #f="ngForm" (ngSubmit)="onSubmit(f)" novalidate *ngIf="loaded">
          <div class="row">
            <div class="col-md-3 mb-3">
              <label for="inputTipoParte" class="form-label" i18n>Tipo de Parte (*)</label>
              <select class="form-select" id="inputTipoParte" name="tipo_parte" #tipo_parte="ngModel"
                [(ngModel)]="parte.tipo_parte" required [disabled]="disableInvoicingOptions"
                [ngClass]="{ 'is-invalid': (tipo_parte.invalid && f.submitted) || (tipo_parte.invalid && (tipo_parte.dirty || tipo_parte.touched))}">
                <option value="" disabled selected i18n>Seleccione</option>
                <option value="DEMANDANTE" i18n>DEMANDANTE</option>
                <option value="DEMANDADO" i18n>DEMANDADO</option>
              </select>
              <div
                *ngIf="(tipo_parte.invalid && f.submitted) || (tipo_parte.invalid && (tipo_parte.dirty || tipo_parte.touched))">
                <p class="validator-message" i18n>Campo obligatorio</p>
              </div>
            </div>

            <div class="col-md-2 mb-3">
              <label for="inputCif" class="form-label" i18n>CIF (*)</label>
              <input type="text" class="form-control" id="inputCif" name="cif" #cif="ngModel" [(ngModel)]="parte.cif"
                required
                [ngClass]="{ 'is-invalid': (cif.invalid && f.submitted) || (cif.invalid && (cif.dirty || cif.touched))}">
              <div *ngIf="(cif.invalid && f.submitted) || (cif.invalid && (cif.dirty || cif.touched))">
                <p class="validator-message" i18n>Campo obligatorio</p>
              </div>
            </div>

            <div class="col-md-4 mb-3">
              <label for="inputRazonSocial" class="form-label" i18n>Razón Social (*)</label>
              <input type="text" class="form-control" id="inputRazonSocial" name="razon_social" #razon_social="ngModel"
                [(ngModel)]="parte.razon_social" required
                [ngClass]="{ 'is-invalid': (razon_social.invalid && f.submitted) || (razon_social.invalid && (razon_social.dirty || razon_social.touched))}">
              <div
                *ngIf="(razon_social.invalid && f.submitted) || (razon_social.invalid && (razon_social.dirty || razon_social.touched))">
                <p class="validator-message" i18n>Campo obligatorio</p>
              </div>
            </div>

            <div class="col-md-3 mb-3">
              <label for="inputDireccion" class="form-label" i18n>Dirección</label>
              <input type="text" class="form-control" id="inputDireccion" name="direccion" #direccion="ngModel"
                [(ngModel)]="parte.direccion"
                [ngClass]="{ 'is-invalid': (direccion.invalid && f.submitted) || (direccion.invalid && (direccion.dirty || direccion.touched))}">
              <div
                *ngIf="(direccion.invalid && f.submitted) || (direccion.invalid && (direccion.dirty || direccion.touched))">
                <p class="validator-message" i18n>Campo obligatorio</p>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-3 mb-3">
              <label for="inputCodigoPostal" class="form-label" i18n>Código Postal</label>
              <input type="text" class="form-control" id="inputCodigoPostal" name="codigo_postal"
                #codigo_postal="ngModel" [(ngModel)]="parte.codigo_postal"
                [ngClass]="{ 'is-invalid': (codigo_postal.invalid && f.submitted) || (codigo_postal.invalid && (codigo_postal.dirty || codigo_postal.touched))}">
              <div
                *ngIf="(codigo_postal.invalid && f.submitted) || (codigo_postal.invalid && (codigo_postal.dirty || codigo_postal.touched))">
                <p class="validator-message" i18n>Campo obligatorio</p>
              </div>
            </div>

            <div class="col-md-3 mb-3">
              <label for="inputPoblacion" class="form-label" i18n>Población</label>
              <input type="text" class="form-control" id="inputPoblacion" name="poblacion" #poblacion="ngModel"
                [(ngModel)]="parte.poblacion"
                [ngClass]="{ 'is-invalid': (poblacion.invalid && f.submitted) || (poblacion.invalid && (poblacion.dirty || poblacion.touched))}">
              <div
                *ngIf="(poblacion.invalid && f.submitted) || (poblacion.invalid && (poblacion.dirty || poblacion.touched))">
                <p class="validator-message" i18n>Campo obligatorio</p>
              </div>
            </div>

            <div class="col-md-3 mb-3">
              <label for="inputProvincia" class="form-label" i18n>Provincia</label>
              <input type="text" class="form-control" id="inputProvincia" name="provincia" #provincia="ngModel"
                [(ngModel)]="parte.provincia"
                [ngClass]="{ 'is-invalid': (provincia.invalid && f.submitted) || (provincia.invalid && (provincia.dirty || provincia.touched))}">
              <div
                *ngIf="(provincia.invalid && f.submitted) || (provincia.invalid && (provincia.dirty || provincia.touched))">
                <p class="validator-message" i18n>Campo obligatorio</p>
              </div>
            </div>

            <div class="col-md-3 mb-3">
              <label for="selectNacionalidad" class="form-label" i18n>Nacionalidad</label>
              <select2 [data]="nacionalidades" i18n-placeholder="@@nacionalidadesPlaceholder" placeholder="Nacionalidad"
                id="selectNacionalidad" name="nacionalidad" #nacionalidad="ngModel" [(ngModel)]="parte.nacionalidad" multiple="false"
                displaySearchStatus="always" noLabelTemplate="true"
                [ngClass]="{ 'is-invalid': (nacionalidad.invalid && f.submitted) || (nacionalidad.invalid && (nacionalidad.dirty || nacionalidad.touched))}">
              </select2>
              <div
                *ngIf="(nacionalidad.invalid && f.submitted) || (nacionalidad.invalid && (nacionalidad.dirty || nacionalidad.touched))">
                <p class="validator-message" i18n>Campo obligatorio</p>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-3 mb-4">
              <label for="inputImpuestoAplicable" class="form-label" i18n>Impuesto Aplicable (*)</label>
              <input 
                type="text" 
                class="form-control" 
                id="inputImpuestoAplicable" 
                name="impuesto_aplicable" 
                #impuesto_aplicable="ngModel" 
                [(ngModel)]="parte.impuesto_aplicable"
                required
                maxlength="6"
                pattern="^([0-9]{1,2}(,[0-9]{1,2})?|100)$"
                [ngClass]="{ 'is-invalid': (impuesto_aplicable.invalid && f.submitted) || (impuesto_aplicable.invalid && (impuesto_aplicable.dirty || impuesto_aplicable.touched))}">
              <div *ngIf="(impuesto_aplicable.invalid && f.submitted) || (impuesto_aplicable.invalid && (impuesto_aplicable.dirty || impuesto_aplicable.touched))">
                <p class="validator-message" i18n>Decimal entre 0 y 100</p>
              </div>
            </div>
            
            <div class="col-md-3 mb-4">
              <label for="inputPorcentajeImputable" class="form-label" i18n>Porcentaje Imputable (*)</label>
              <input 
                type="text" 
                class="form-control" 
                id="inputPorcentajeImputable" 
                name="porcentaje_imputable" 
                #porcentaje_imputable="ngModel" 
                [(ngModel)]="parte.porcentaje_imputable"
                (ngModelChange)="onPorcentajeImputableChange($event)"
                required
                maxlength="6"
                pattern="^([0-9]{1,2}(,[0-9]{1,2})?|100)$"
                [readonly]="disableInvoicingOptions"
                [ngClass]="{ 'is-invalid': (porcentaje_imputable.invalid && f.submitted) || (porcentaje_imputable.invalid && (porcentaje_imputable.dirty || porcentaje_imputable.touched))}">
              <div *ngIf="(porcentaje_imputable.invalid && f.submitted) || (porcentaje_imputable.invalid && (porcentaje_imputable.dirty || porcentaje_imputable.touched))">
                <p class="validator-message" i18n>Decimal entre 0 y 100</p>
              </div>
            </div>
          </div>
          

          <div class="row">
            <div class="col-md-12 mb-3">
              <label for="inputComentarios" class="form-label" i18n>Comentarios</label>
              <textarea class="form-control" id="inputComentarios" name="comentarios" #comentarios="ngModel"
                [(ngModel)]="parte.comentarios" [readonly]="disableInvoicingOptions"
                [ngClass]="{ 'is-invalid': (comentarios.invalid && f.submitted) || (comentarios.invalid && (comentarios.dirty || comentarios.touched))}"></textarea>
              <div
                *ngIf="(comentarios.invalid && f.submitted) || (comentarios.invalid && (comentarios.dirty || comentarios.touched))">
                <p class="validator-message" i18n>Campo obligatorio</p>
              </div>
            </div>
          </div>

          <div class="text-md-end" *ngIf="!disableNoAdmin">
            <button type="submit" class="btn btn-primary waves-effect waves-light"><span i18n>Guardar</span></button>
          </div>
        </form>

        <div id="status" *ngIf="!loaded && !error">
          <div class="spinner">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>

      </div> <!-- end card-body -->
    </div> <!-- end card-->
  </div> <!-- end col -->
</div>
<!-- end row -->
